module.exports = __webpack_public_path__ + "static/media/Deployment.711e2aa7.png";